import { render, staticRenderFns } from "./songswapshowdown.vue?vue&type=template&id=40c38242&scoped=true&"
import script from "./songswapshowdown.vue?vue&type=script&lang=js&"
export * from "./songswapshowdown.vue?vue&type=script&lang=js&"
import style0 from "./songswapshowdown.vue?vue&type=style&index=0&id=40c38242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c38242",
  null
  
)

export default component.exports